export const BOOKING_EXPERIENCE = "Booking your experience";
export const SAVING_TRAVELERS_AND_CHECKING_AVAILABILITY =
  "Saving travelers and checking availability";
